import {
  BookableEmployeeType,
  PrenotabiliPerCorso,
  VociPrenotabili,
} from "../../types";

function perNome(a: BookableEmployeeType, b: BookableEmployeeType): number {
  return a.name.localeCompare(b.name);
}

// I prenotabili di un corso dalla risposta batch, come voci della tendina
// PRENOTA ("COGNOME NOME" in maiuscolo, ordinate per nome mostrato). Un corso
// assente dal batch, o senza codice (vecchi import), non ha prenotabili.
export function prenotabiliDelCorso(
  prenotabili: PrenotabiliPerCorso,
  codiceCorso: string | undefined
): BookableEmployeeType[] {
  if (!codiceCorso) return [];
  return (prenotabili[codiceCorso] ?? [])
    .map((d) => ({
      cf: d.cf,
      name: `${d.lastName} ${d.firstName}`.toUpperCase(),
    }))
    .sort(perNome);
}

// Tutti i corsi del batch, ciascuno con le proprie voci di tendina.
export function mappaPrenotabili(
  prenotabili: PrenotabiliPerCorso
): VociPrenotabili {
  const voci: VociPrenotabili = {};
  Object.keys(prenotabili).forEach((codice) => {
    voci[codice] = prenotabiliDelCorso(prenotabili, codice);
  });
  return voci;
}

// Dopo un'assegnazione: il dipendente non è più prenotabile a quel corso.
export function senzaPrenotabile(
  voci: VociPrenotabili,
  codiceCorso: string,
  cf: string
): VociPrenotabili {
  return {
    ...voci,
    [codiceCorso]: (voci[codiceCorso] ?? []).filter((e) => e.cf !== cf),
  };
}

// Dopo l'annullamento di un'assegnazione: il dipendente torna prenotabile a
// quel corso, al suo posto nell'ordine per nome.
export function conPrenotabile(
  voci: VociPrenotabili,
  codiceCorso: string,
  voce: BookableEmployeeType
): VociPrenotabili {
  return {
    ...voci,
    [codiceCorso]: [...(voci[codiceCorso] ?? []), voce].sort(perNome),
  };
}
